import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { useAsset, useTenant } from '../../hooks'
import { useActions } from '../../store'

const DEFAULT_ASSETS = {
  applicationName: 'Portal',
  imgSrcLogin: '/login.png',
  imgAltLogin:
    'Background image featuring the Ohio State seal, representing the university’s central campus',
  imgSrcLogo: '/logo.png',
  imgAltLogo:
    'Logo of Clinical and Translational Science Institute at The Ohio State University'
}

const AssetsProvider = ({ children }) => {
  const {
    setApplicationName,
    setImgSrcLogin,
    setImgAltLogin,
    setImgSrcLogo,
    setImgAltLogo
  } = useActions()
  const { tenant } = useTenant()
  const { asset: css } = useAsset(tenant?.cssId)
  const { asset: login } = useAsset(tenant?.loginImageId)
  const { asset: logo } = useAsset(tenant?.logoImageId)

  setApplicationName(
    tenant
      ? `${tenant.name} - ${DEFAULT_ASSETS.applicationName}`
      : DEFAULT_ASSETS.applicationName
  )
  setImgSrcLogin(
    login
      ? `data:${login.contentType};base64,${login.content}`
      : DEFAULT_ASSETS.imgSrcLogin
  )
  setImgAltLogin(login ? login.altText : DEFAULT_ASSETS.imgAltLogin)
  setImgSrcLogo(
    logo
      ? `data:${logo.contentType};base64,${logo.content}`
      : DEFAULT_ASSETS.imgSrcLogo
  )
  setImgAltLogo(logo ? logo.altText : DEFAULT_ASSETS.imgAltLogo)

  return (
    <>
      {
        <Helmet>
          <link
            rel='stylesheet'
            type='text/css'
            href={
              css
                ? `data:${css.contentType};base64,${css.content}`
                : '/main.css'
            }
          />
        </Helmet>
      }
      {children}
    </>
  )
}

AssetsProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export { AssetsProvider, DEFAULT_ASSETS }
